import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChalkboardUser, faCircleCheck, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import RateCheck from './RateCheck';
import './CourseRates.css';

const API = process.env.REACT_APP_API_BASE_URL;
const BASE = `${API}/api/admin/Prices/course-rates`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('userData')}` } });
const LEVEL = { little: 'Little', junior: 'Junior' };

/* Prices & Offers › Teacher rate per course.
   When you approve a class feedback, the rate is the one of the course the teacher submitted. */
const CourseRates = () => {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(null);
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    let alive = true;
    axios
      .get(BASE, auth())
      .then((res) => alive && setData(res.data))
      .catch((err) => alive && setData({ courses: [], ready: false, error: err.response?.data?.error || 'We couldn’t load the courses.' }));
    return () => {
      alive = false;
    };
  }, []);

  // Standard / Mastery: which paid sessions a class of this course uses
  const setType = async (c, type) => {
    if (c.type === type && c.typeSet) return;
    setSaving(c.id);
    setMsg(null);
    try {
      await axios.put(`${BASE}/${c.id}/type`, { type }, auth());
      setData((d) => ({ ...d, courses: d.courses.map((x) => (x.id === c.id ? { ...x, type, typeSet: true } : x)) }));
      setMsg({ ok: true, text: `${c.name}: ${type === 'mastery' ? 'Mastery & Robotics' : 'Standard'} course` });
    } catch (err) {
      setMsg({ ok: false, text: err.response?.data?.error || 'Couldn’t save.' });
    } finally {
      setSaving(null);
    }
  };


  if (!data) return <section className="rmcr"><div className="rmcr-skel" /></section>;

  return (
    <section className="rmcr" aria-labelledby="rmcr-title">
      <h2 id="rmcr-title">
        <FontAwesomeIcon icon={faChalkboardUser} /> Course type: Standard or Mastery
      </h2>
      <p className="rmcr-sub">
        The course decides the type, the teacher decides the price. When you approve a class, the teacher is paid her own Standard or
        Mastery rate (set on each teacher’s profile, tab “Pay &amp; stats”). The type also says which paid sessions the course uses.
      </p>
      {data.error && <p className="rmcr-msg is-bad">{data.error}</p>}
      {!data.typesReady && !data.error && <p className="rmcr-msg is-bad">Run SessionTypes.sql on the server to choose the course types.</p>}
      {msg && (
        <p className={`rmcr-msg ${msg.ok ? '' : 'is-bad'}`} role="status">
          <FontAwesomeIcon icon={msg.ok ? faCircleCheck : faTriangleExclamation} /> {msg.text}
        </p>
      )}
      <ul className="rmcr-list">
        {data.courses.map((c) => (
          <li key={c.id}>
            <div className="rmcr-name">
              <b>{c.name}</b>
              <span>
                {c.levels.map((l) => (
                  <i key={l} className={`is-${l}`}>
                    {LEVEL[l]}
                  </i>
                ))}
              </span>
            </div>
            {data.typesReady && (
              <div className="rmcr-type" role="group" aria-label={`Type of ${c.name}`}>
                {[
                  ['standard', 'Standard'],
                  ['mastery', 'Mastery'],
                ].map(([k, l]) => (
                  <button
                    key={k}
                    type="button"
                    className={`is-${k} ${c.type === k ? 'is-on' : ''}`}
                    onClick={() => setType(c, k)}
                    disabled={saving === c.id}
                  >
                    {l}
                  </button>
                ))}
              </div>
            )}
          </li>
        ))}
      </ul>

      <RateCheck />
    </section>
  );
};

export default CourseRates;
